module.exports = __webpack_public_path__ + "static/media/visamaster.702787ba.png";